import React from "react";

interface CheckboxDefaultProps {
  color?: string;
  strokeWidth?: number;
}

export const CheckboxDefault = ({ color = "#D8DBE0", strokeWidth = 1.75 }: CheckboxDefaultProps) => (
<svg
  width="19"
  height="19"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
    <path
      d="M2.5 1.5H17.5C17.7652 1.5 18.0195 1.60543 18.207 1.79297C18.3946 1.9805 18.5 2.23478 18.5 2.5V17.5C18.5 17.7652 18.3946 18.0195 18.207 18.207C18.0195 18.3946 17.7652 18.5 17.5 18.5H2.5C2.23478 18.5 1.9805 18.3946 1.79297 18.207C1.60543 18.0195 1.5 17.7652 1.5 17.5V2.5C1.5 2.23478 1.60543 1.98051 1.79297 1.79297C1.98051 1.60543 2.23478 1.5 2.5 1.5Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
</svg>

);

